module.exports = __webpack_public_path__ + "img/deepseek-send@2x.25f57d5d.png";